<template>
    <a-drawer :title="$t('program.unplanned_members_drawer_title' /* 查看未安排学术任务委员名单 */)" width="85%" placement="right" :closable="true" :visible="visible" @close="handleDrawerClose">
        <a-spin :spinning="loading">
            <a-form class="mb20" :form="form" :layout="isShowList ? 'inline' : 'horizontal'">
                <a-row v-if="!isShowList">
                    <a-col>
                        <a-form-item :label="$t('program.select_branch' /* 选择分会 */)">
                            <a-select :placeholder="$t('program.please_select' /* 请选择 */)" v-decorator="['branch_id', { rules: [{ required: true }] }]">
                                <a-select-option v-for="item in committeeList" :key="item.id" :value="item.id">
                                    {{ item.name }}
                                </a-select-option>
                            </a-select>
                        </a-form-item>
                        <a-form-item>
                            <div class="flex x-center mt20">
                                <a-button type="primary" size="large" style="width: 20%" @click="handleViewEvent">{{ $t('program.click_to_view' /* 点击查看 */) }}</a-button>
                            </div>
                        </a-form-item>
                    </a-col>
                </a-row>

                <a-row v-else>
                    <a-col>
                        <a-form-item :label="$t('program.keyword' /* 关键字 */)">
                            <a-input style="width: 150px" v-decorator="['member_info']" :placeholder="$t('program.name_phone_email' /* 姓名/手机号/邮箱 */)"></a-input>
                        </a-form-item>
                        <a-form-item :label="$t('web.company' /* 单位 */)">
                            <a-input style="width: 150px" v-decorator="['org_cnname']" :placeholder="$t('web.company' /* 单位 */)"></a-input>
                        </a-form-item>
                        <a-form-item :label="$t('program.task_allocation_label' /* 任务安排 */)">
                            <a-select style="width: 150px" :placeholder="$t('program.please_select' /* 请选择 */)" v-decorator="['duty_count', { initialValue: 0 }]">
                                <a-select-option :value="1">{{ $t('program.arranged' /* 已安排 */) }}</a-select-option>
                                <a-select-option :value="0">{{ $t('program.unarranged' /* 未安排 */) }}</a-select-option>
                            </a-select>
                        </a-form-item>
                        <a-form-item>
                            <a-button type="primary" @click="handleSearchEvent">{{ $t('web.query' /* 查询 */) }}</a-button>
                        </a-form-item>
                    </a-col>
                </a-row>
            </a-form>

            <!-- 表格 -->
            <div v-show="isShowList">
                <div class="pb10 pt10 pl10 pr10" style="border: 1px solid rgb(235, 237, 240)">
                    <span style="color: #0b69f6">{{ pageTitle }}</span>
                    {{ $t('program.committee_task_allocation' /* 委员任务安排：已安排 */) }}
                    <span style="color: #f00">{{ membersInfo.already_arranged_count }}</span>
                    {{ $t('program.people' /* 人 ，未安排 */) }}
                    <span style="color: #f00">{{ membersInfo.not_arranged_count }}</span>
                    {{ $t('program.people' /* 人 */) }}
                </div>
                <div class="t-r mb10 mt10">
                    <a-button type="primary" @click="handleExportEvent">{{ $t('program.export_unplanned_members_list' /* 导出未安排学术任务委员名单 */) }}</a-button>
                </div>
                <a-table
                    ref="table"
                    :rowKey="record => record.id"
                    :columns="columns"
                    :data-source="dataSource"
                    :pagination="pagination"
                    :scroll="{ x: 1000 }"
                    @change="handleTableChange"
                    @showSizeChange="handleTableChange"
                >
                    <template slot="duty_count" slot-scope="text">
                        <div :style="{ color: text > 0 ? 'green' : 'red' }">{{ text }}</div>
                    </template>
                </a-table>
            </div>
        </a-spin>
    </a-drawer>
</template>

<script>
export default {
    name: 'unplannedMembersDrawer',
    components: {},
    data() {
        return {
            visible: false,
            committeeList: [],
            dataSource: [],
            loading: false,
            form: this.$form.createForm(this),
            pageTitle: '',
            membersInfo: {}, // 委员会信息
            branch_id: '', // 已关联分会
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0,
                showTotal: total => this.$t('web.pagination_total', { value: total } /* 共 {total} 条 */),
                showSizeChanger: true,
                showQuickJumper: true,
                pageSizeOptions: ['10', '30', '50', '100']
            },
            isShowList: false,
            branch_id: '',
            columns: [
                {
                    title: this.$t('program.user_id' /* 用户ID */),
                    dataIndex: 'UserID',
                    align: 'left',
                    fixed: 'left',
                    width: 100
                },
                {
                    title: this.$t('web.name' /* 姓名 */),
                    dataIndex: 'real_name',
                    align: 'left',
                    width: 120
                },
                {
                    title: this.$t('web.company' /* 单位 */),
                    dataIndex: 'org_cnname',
                    align: 'left'
                },
                {
                    title: this.$t('web.department' /* 科室 */),
                    dataIndex: 'department',
                    align: 'left',
                    width: 150
                },
                {
                    title: this.$t('program.position' /* 任职 */),
                    dataIndex: 'position',
                    align: 'left',
                    width: 150
                },
                {
                    title: this.$t('program.task_allocation_label' /* 任务安排 */),
                    dataIndex: 'duty_count',
                    scopedSlots: { customRender: 'duty_count' },
                    align: 'left',
                    width: 120
                }
            ]
        };
    },
    computed: {},
    methods: {
        show() {
            this.visible = true;
            this.getBranchList();
        },
        //关闭抽屉
        handleDrawerClose() {
            this.dataSource = [];
            this.form.resetFields();
            this.visible = false;
        },

        // 获取列表数据
        getBranchList() {
            this.$request.get({ url: 'getBranchList' }).then(res => {
                this.committeeList = res.data.committee_list;
                // TODO:
                this.committeeList.push({ id: '4388', name: '我的测试' });
                this.branch_id = res.data.branch_id;
                this.isShowList = this.branch_id ? true : false;
                if (this.isShowList) {
                    this.getMembersInfo();
                }
            });
        },
        // 获取届次数据
        getMembersInfo() {
            this.$request
                .get({ url: 'verifyMemberDuty', data: { committee_id: this.form.getFieldValue('branch_id') || this.branch_id } })
                .then(res => {
                    this.isShowList = true;
                    this.membersInfo = res.data;
                    this.pageTitle = `${this.membersInfo.committee_name}${this.membersInfo.sequence > 0 ? this.$t('web.first' /* 第 */) : ''}${
                        this.membersInfo.sequence ? this.numberToChinese(this.membersInfo.sequence) : ''
                    }${this.membersInfo.sequence > 0 ? this.$t('web.the_session' /* 届 */) : ''}${this.membersInfo.org_name ? this.membersInfo.org_name : ''}`;
                    this.getMembersList();
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        // 获取委员列表数据
        getMembersList() {
            let data = {
                ...this.form.getFieldsValue(),
                page: this.pagination.current,
                limit: this.pagination.pageSize,
                period_id: this.form.getFieldValue('branch_id') || this.branch_id
            };
            this.loading = true;
            this.$request
                .get({ url: 'getMemberDutyList', data })
                .then(res => {
                    this.dataSource = res.data.list;
                    this.pagination.total = Number(res.data.count);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        // 表格变化
        handleTableChange(pagination) {
            this.pagination.current = pagination.current;
            this.pagination.pageSize = pagination.pageSize;
            this.getMembersList();
        },
        // 搜索
        handleSearchEvent() {
            this.pagination.current = 1;
            this.getMembersList();
        },
        /**
         * ## 格式化数字
         * @param num
         */
        numberToChinese(num) {
            if (num === 0) {
                return '零';
            }

            const chineseNumbers = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
            const chineseUnits = ['', '十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千', '万', '十', '百', '千'];

            let parts = [];
            let needZero = false;

            for (let i = 0; num > 0; i++) {
                let digit = num % 10;
                if (digit === 0) {
                    needZero = true;
                } else {
                    if (needZero) {
                        parts.push(chineseNumbers[0]);
                        needZero = false;
                    }
                    if (i === 1 && digit === 1 && (parts.length === 0 || parts[parts.length - 1] === chineseUnits[4] || parts[parts.length - 1] === chineseUnits[8])) {
                        parts.push(chineseUnits[i].slice(1)); // 处理“一十”为“十”的情况
                    } else {
                        parts.push(chineseUnits[i]);
                        parts.push(chineseNumbers[digit]);
                    }
                }
                num = Math.floor(num / 10);
            }

            let result = parts.reverse().join('');

            // 去除末尾的“零”
            result = result.replace(/零+$/, '');

            // 去除中间多余的“零”
            result = result.replace(/零+/g, '零');

            // 处理“零万”、“零亿”等情况
            result = result.replace(/零万/g, '万');
            result = result.replace(/零亿/g, '亿');

            // 处理“亿万”为“亿”
            result = result.replace(/亿万/g, '亿');

            return result;
        },
        // 查看列表
        handleViewEvent() {
            if (!this.form.getFieldValue('branch_id')) {
                this.$message.warning(this.$t('program.please_select_branch' /* 请先选择分会 */));
                return;
            }
            this.getMembersInfo();
        },
        // 导出列表
        handleExportEvent() {
            let { domain } = this.$store.state.meetingInfo;
            let baseUrl = `${domain}/program/duty/member-duty-list-export/`;
            const query = this.form.getFieldsValue();
            let exportUrl = `${baseUrl}${this.$route.params.meeting_id}?period_id=${this.branch_id}&member_info=${query.member_info}&org_cnname=${query.org_cnname}&duty_count=${query.duty_count}`;
            window.location.href = exportUrl;
        }
    },
    created() {},
    mounted() {}
};
</script>
<style lang='less' scoped>
::v-deep .ant-checkbox-group {
    width: 100%;
}
.filter-form {
    background-color: #fafafa;
    border: 1px solid #eee;
    border-radius: 3px;
    padding: 10px 15px;
}
::v-deep .ant-drawer-body {
    max-height: 72vh;
    overflow-y: auto;
}
::v-deep .ant-form-item {
    margin-bottom: 5px;
}
</style>